<script setup lang="ts">
console.log('版本号：', process.env.version)
</script>

<template>
  <ConfigGlobal>
    <router-view />
  </ConfigGlobal>
</template>
